import Box from "@mui/material/Box"
import {Typography} from "@mui/material";
import Alert from "assets/svg/Alert.svg"

export const ConnexionError = () => {
    return (
        <Box sx={{
            display: "flex",
            alignItems: 'center',
            flexDirection: 'row',
            backgroundColor: '#faced4',
            borderRadius: '25px',
            padding: '10px',
            width: '60%'
        }}>
            <img src={Alert} />
            <Typography sx={{paddingLeft: '10px'}} align='center' data-cy={"error-message"}> Nous vous prions de nous excuser mais une erreur inattendue est intervenue. Veuillez réessayer plus tard. </Typography>
        </Box>
    )
}